import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const services = [
  {
    name: "Leadership Development",
    desc: "Building the clarity, presence and resilience leaders need to move fast without losing their people.",
  },
  {
    name: "Organisational Design",
    desc: "Structuring teams and reporting lines for accountability, speed and room to scale.",
  },
  {
    name: "Product Strategy",
    desc: "Shaping direction and decision-making frameworks that keep growth focused on what matters.",
  },
  {
    name: "Growth Architecture",
    desc: "Designing the operating systems — processes, rituals, culture — that make scaling repeatable.",
  },
  {
    name: "Culture & Change",
    desc: "Embedding the mindset shifts that make transformation last beyond the programme.",
  },
]

export function Services() {
  const rowRefs = useRef([])

  useEffect(() => {
    document.body.style.backgroundColor = ""
    document.body.style.color = ""

    const ctx = gsap.context(() => {
      rowRefs.current.forEach((row) => {
        gsap.fromTo(
          row,
          { opacity: 0, y: 24 },
          {
            opacity: 1,
            y: 0,
            duration: 0.7,
            ease: "power3.out",
            scrollTrigger: { trigger: row, start: "top 90%" },
          }
        )
      })
      ScrollTrigger.refresh()
    })

    return () => ctx.revert()
  }, [])

  return (
    <div className="services-page">
      <div className="services-header">
        <p className="eyebrow">What we do</p>
        <h1 className="services-headline">We help organisations scale by developing the tools, methods and practices that make growth last.</h1>
      </div>

      <div className="services-table">
        {services.map((service, i) => (
          <div key={i} ref={el => (rowRefs.current[i] = el)} className="service-row">
            <span className="service-name">{service.name}</span>
            <span className="service-desc">{service.desc}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
